import { combineReducers } from 'redux';
import { AUTH } from './auth/reducer';

// Reducers
import patientInfo from 'views/patient/Profile/reducer';
import registration from 'views/patient/SignUp/reducer';
import reservation from 'views/patient/Reservation/reducer';
import dashboard from 'views/patient/Dashboard/reducer';
import common from 'views/patient/reducer/commonReducer';

const patientReducer = combineReducers({
  common,
  dashboard,
  patientInfo,
  registration,
  reservation
});

export default (state, action) => {
  if (action.type === AUTH.LOGOUT_ERROR || action.type === AUTH.LOGOUT_SUCCESS) {
    state = undefined;
  }
  return patientReducer(state, action);
};
